export const theme = {
  colors: {
    white: '#FEFEFE',
    offWhite: '#F3F3F3',
    // --grey: #f9f9f9; /* Lightest grey */
    // --grey1: #f1f1f1; /* Slightly darker than grey */
    // --grey2: #ddd; /* Subtle border grey */
    // --grey3: #b3b0b0; /* Medium grey */
    // --grey4: #757575; /* Darker grey for text */
    // --grey5: #515151; /* Dark grey for headings */
    // --grey6: #343434; /* Very dark grey */
    // --grey7: #171717; /* Almost black */
    // Give me the above greys in this syntax: grey: '#f9f9f9',
    // grey: ,
    // grey1: '#f1f1f1',
    // grey2: '#ddd',
    // grey3: '##b3b0b0',
    grey: '#e6e6e6',
    grey0: '#f4f3f3',
    grey1: '#dad9d9',
    grey15: '#f1f1f1',
    grey2: '#B3B0B0',
    grey25: '#ddd',
    grey3: '#757575',
    grey4: '#515151',
    grey5: '#343434',
    grey6: '#262626',
    grey7: '#171717',
    yellow1: '#fff0c2',
    yellow2: '#ffd66b',
    yellow3: '#fbe49a',
    yellow4: '#fed242',
    yellow5: '#ffc933',
    orange1: '#F6D29D',
    orange2: '#F2AF17',
    orange3: '#EDA845',
    orange4: '#EA9A26', // kept
    orange5: '#E68B07', // kept
    orangeMuted: '#E9B66A',
    orangeSoft: '#F8E6D0',

    // primary semantic
    black: '#1D1D1D',

    // Blues / Teal
    blue1: '#e3f0fc',
    blue2: '#90caf9',
    blue3: '#1976d2',
    infoBlue: '#2196f3',
    teal1: '#4db6ac',
    teal2: '#008080',
    teal3: '#054a57',

    // status
    lightRed: '#ffe4e5',
    errorRed: 'hsl(354, 85%, 44%)',
    lightGreen: '#eefeef',
    successGreen: '#3b8239',

    // button background (kept as gradient)
    buttonBackground: `linear-gradient(
      160deg,
      #fadd7f 0%,
      #FDDC5E 33%,
      #facc4c 66%,
      #f7b456 100%
    );`,
  },
  spacing: {
    xxxs: '0.15rem',
    xxs: '0.25rem',
    xs: '0.5rem',
    s: '0.75rem',
    m: '1rem',
    l: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
    xxxl: '4rem',
    xxxxl: '6rem',
    xxxxxl: '8rem',
    xxxxxxl: '12rem',
    xxxxxxxl: '16rem',
    xxxxxxxxl: '24rem',
  },
  animations: {
    fadeIn: 'fade-in 0.3s ease-in-out',
    fadeOut: 'fade-out 0.3s ease-in-out',
    slideIn: 'slide-in 0.3s ease-in-out',
    slideOut: 'slide-out 0.3s ease-in-out',
  },
  shadows: {
    shadow1: '0 2px 12px rgba(0, 0, 0, 0.07)',
    shadow2: '0 2px 8px rgba(25, 118, 210, 0.08)',
    shadow3: '0 5px 15px hsla(0, 0%, 0%, 0.2)',
    shadow4: '0 10px 24px hsla(0, 0%, 0%, 0.2)',
    shadow5: '0 15px 35px hsla(0, 0%, 0%, 0.2)',
    overlapShadow: '0 4px 6px rgba(0,0,0,.7), 0 5px 15px rgba(0,0,0,0.1)',
    hover:
      '0 3px 6px 1px rgba(242,175,23,0.18), 0 3px 5px 1px rgba(234,154,38,0.08)',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.12)',
  },
  borderRadius: '4px',
  letterSpacing: {
    courseTitles: '0.08rem',
  },
};
